import { memo } from 'react';

import {
  Dialog,
  DialogTrigger,
  DialogContent,
  DialogHeader,
  DialogTitle
} from '@/shadcn/dialog';

import { cn } from '@/shadcn/lib/utils';

type Props = React.PropsWithChildren<{
  title: React.ReactNode;
  body: any;
  large?: boolean;
  fullscreen?: boolean;
}>;

export const ModalWrapper = memo(
  ({ children, title, body, fullscreen = false }: Props) => {
    // Marked as updated, if the widget wrap by the tray has an update
    // If we don't do that, the update mark will only be displayed when the modal is opened
    if (body.props) {
      const { widget, update = {} } = body.props;
      const viewPath = widget.view.path;

      if (update) {
        const { patch, setIsPatched } = update;

        if (patch && setIsPatched && viewPath in patch) {
          setIsPatched(true);
        }
      }
    }

    return (
      <Dialog>
        <DialogTrigger asChild>
          <div className="size-full">{children}</div>
        </DialogTrigger>
        <DialogContent
          className={cn(
            'max-w-[800px]',
            fullscreen && 'w-[calc(100vw-2rem)] max-w-none'
          )}
        >
          <DialogHeader>
            <DialogTitle>{title ?? 'Data'}</DialogTitle>
          </DialogHeader>

          <div className="text-foreground overflow-y-auto text-[13px] leading-[1.25]">
            <div className="size-full overflow-auto">{body}</div>
          </div>
        </DialogContent>
      </Dialog>
    );
  }
);
